const PC_DESIGN_BASE = 1920 // 设计稿基准宽度，全站 rem 按此稿编写
const minRootPx = 50 // 仅大屏 PC（≥1920）根字号下限

/**
 * 档位规则：min 严格降序，第一个满足 width >= min 的 design 为除数。
 * 当前仅锁定 PC 大屏为 1920 稿；宽度 < 1920（iPad 等）回退到 PC_DESIGN_BASE 做等比缩放。
 *
 * 说明：若启用 1024/768 等档位且根字号仍约 100px，需配套各档位的 rem 样式（媒体查询）；
 * 现在只有一套 1920 rem，小屏应整页等比缩小，不能单独切 design 档。
 */
const PC_DESIGN_TIERS = [
  { min: 1920, design: 1920 }
  /* 若日后为 iPad 单独写稿，可再开档位 + 对应 @media 覆盖 rem：
  { min: 1600, design: 1600 },
  { min: 1366, design: 1366 },
  { min: 1024, design: 1024 },
  { min: 820, design: 820 },
  { min: 768, design: 768 },
  */
]

function getDesignWidth(width) {
  for (let i = 0; i < PC_DESIGN_TIERS.length; i++) {
    const { min, design } = PC_DESIGN_TIERS[i]
    if (width >= min) return design
  }
  // iPad / 小屏：仍用 1920 稿等比缩放，与 PC 同一套 rem 数值
  return PC_DESIGN_BASE
}

function setRem() {
  const docEl = document.documentElement
  const width = docEl.clientWidth
  if (!width) return

  const offset = getDesignWidth(width)
  window.offset = offset

  let rootPx = (width / offset) * 100
  // 仅 ≥1920 保底字号；小屏若强行抬到 50px 会撑破视口（约 960px 以下都会溢出）
  if (width >= PC_DESIGN_BASE && rootPx < minRootPx) {
    rootPx = minRootPx
  }

  docEl.style.fontSize = Math.round(rootPx) + 'px'
}

export function initRem() {
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  setRem()
  window.addEventListener(resizeEvt, setRem, false)
  window.addEventListener('load', setRem, false)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setRem, false)
  } else {
    requestAnimationFrame(setRem)
  }
}
